import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Response } from '@angular/http';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

import { Additionalflat } from './additionalflat.model';
import { AdditionalflatPopupService } from './additionalflat-popup.service';
import { AdditionalflatService } from './additionalflat.service';
import { Marketplace, MarketplaceService } from '../marketplace';

@Component({
    selector: 'jhi-additionalflat-dialog',
    templateUrl: './additionalflat-dialog.component.html'
})
export class AdditionalflatDialogComponent implements OnInit {

    additionalflat: Additionalflat;
    authorities: any[];
    isSaving: boolean;

    marketplaces: Marketplace[];
    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        private alertService: AlertService,
        private additionalflatService: AdditionalflatService,
        private marketplaceService: MarketplaceService,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['additionalflat']);
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.marketplaceService.query().subscribe(
            (res: Response) => { this.marketplaces = res.json(); }, (res: Response) => this.onError(res.json()));
    }
    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        this.isSaving = true;
        if (this.additionalflat.id !== undefined) {
            this.additionalflatService.update(this.additionalflat)
                .subscribe((res: Additionalflat) =>
                    this.onSaveSuccess(res), (res: Response) => this.onSaveError(res));
        } else {
            this.additionalflatService.create(this.additionalflat)
                .subscribe((res: Additionalflat) =>
                    this.onSaveSuccess(res), (res: Response) => this.onSaveError(res));
        }
    }

    private onSaveSuccess(result: Additionalflat) {
        this.eventManager.broadcast({ name: 'additionalflatListModification', content: 'OK'});
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        try {
            error.json();
        } catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }

    trackMarketplaceById(index: number, item: Marketplace) {
        return item.id;
    }
}

@Component({
    selector: 'jhi-additionalflat-popup',
    template: ''
})
export class AdditionalflatPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private additionalflatPopupService: AdditionalflatPopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            if ( params['id'] ) {
                this.modalRef = this.additionalflatPopupService
                    .open(AdditionalflatDialogComponent, params['id']);
            } else {
                this.modalRef = this.additionalflatPopupService
                    .open(AdditionalflatDialogComponent);
            }
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/additionalflat/additionalflat-dialog.component.ts